import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const arrowCss = css`
  .popper-arrow {
    position: absolute;
    left: 20px !important;

    &:after {
      content: "";
      position: absolute;
      z-index: 1;
      border: 8px solid transparent;
      border-color: ${withVar(DesignToken.SurfacePrimaryDefault)} ${withVar(DesignToken.SurfacePrimaryDefault)}
        transparent transparent;
      transform-origin: 0 0;
      transform: rotate(-45deg);
    }
  }
  .popper-popup[x-placement^="top"] .popper-arrow {
    top: 100%;

    &:after {
      border-color: transparent transparent ${withVar(DesignToken.SurfacePrimaryDefault)};
      ${withVar(DesignToken.SurfacePrimaryDefault)};
    }
  }
`;
